// @module NetScore.CartErrMessage.CartErrMessage
define('NetScore.CartErrMessage.CartErrMessage.View'
,	[
		'netscore_carterrmessage_carterrmessage.tpl'
	,	'Utils'
	,	'Backbone'
	,	'jQuery'
	,	'underscore'
	,	'LiveOrder.Model'
	]
,	function (
		netscore_carterrmessage_carterrmessage_tpl
	,	Utils
	,	Backbone
	,	jQuery
	,	_
	,	LiveOrderModel
	)
{
	'use strict';
	var cart;
	var livemodel;
	var line;
	var model;
	//var quantity_available;
	 var quantity_ordered;
	 var lineId;
	// @class NetScore.CartErrMessage.CartErrMessage.View @extends Backbone.View
	return Backbone.View.extend({

		template: netscore_carterrmessage_carterrmessage_tpl

	,	initialize: function (options) {

		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {
			
		}

		//@method getContext @return NetScore.CartErrMessage.CartErrMessage.View.Context
	,	getContext: function getContext()
		{
			return {
				lineId:lineId
			};
		}
	});
});
